import { DISMISS_NOTIFICATION, TOGGLE_NOTIFICATION } from '../../ActionsConst';

// workaround for react-router v2 mounting the ProductsPage twice & un-mounting once:
// isActive: not active if value =< 0; active if value > 0;
const initialState = {
  isDismissed: false,
  isActive: 0,
};

const config = (state = initialState, action) => {
  switch (action.type) {
    case DISMISS_NOTIFICATION:
      return { ...state, isDismissed: true };
    case TOGGLE_NOTIFICATION:
      return { ...state, isActive: state.isActive + action.isActive };
    default: {
      return state;
    }
  }
};

export default config;
